module.exports = __webpack_public_path__ + "static/media/img5.b40829a7.jpg";